/**
 * A main menu item
 */
export type MenuItem = {
    ItemType: MenuItemType,
    Id: number,
    Title: string,
    IconPath?: string,
    ClickPath?: string,
    ClickType: MenuItemClickType,
    SortOrder: number,
    Notifications: number,
    CanBeHidden: boolean,
    /**
     * External items only: when true, the user's Okta access token is POSTed to the
     * destination on launch so they arrive already authenticated.
     */
    SendAuthToExternal?: boolean,
    /**
     * Server -> client only. The icons.scss class this app renders with in the header/footer
     * nav row; null means it can't go there.
     */
    HeaderIconClass?: string | null,
    /**
     * Server -> client only. 0-based slot in the user's nav row (after Home), or null when the
     * app isn't in it. Never sent back — see MainMenuService.updateMenuItemsAsync.
     */
    HeaderSortOrder?: number | null
  }
  
  /**
   * For defining what type of menu item being used
   */
  export enum MenuItemType {
      App = 0,
      Student = 1,
      /**
       * Readonly menu item that is NOT in the backend.
       * Pinned to 3: value 2 was the removed Folder type, and menu payloads are cached
       * client-side for 30 minutes, so the numbering must not shift under a stale cache.
       */
      Profile = 3
  }

  /**
   * Posted as HeaderSortOrder to remove an app from the nav row (the server stores NULL). A
   * negative slot reads as "not in the row" everywhere on the client too.
   */
  export const HEADER_SLOT_NONE = -1;

  // Values are explicit because 2 (the retired 'Header' type) must stay unused — cached menu
  // items store the numeric ClickType, so renumbering would misroute External items.
  export enum MenuItemClickType {
    Main = 0,
    Student = 1,
    External = 3
  }
